import React, { FC, Fragment, ReactNode } from 'react'
import { InfoOutlined } from '@mui/icons-material'
import { Dialog } from '../../ui'
import cn from '../../../lib/utils/cn'
import { ClassNameValue } from 'tailwind-merge'

interface InfoItem {
	name: string
	value?: string | ReactNode
	itemClassNameWrapper?: ClassNameValue
	visible?: boolean
}

interface ViewInfoModalProps {
	isOpen: boolean
	onClose: () => void
	title: string
	items: InfoItem[]
}

const ViewInfoModal: FC<ViewInfoModalProps> = ({
	isOpen,
	onClose,
	title,
	items,
}) => {
	if (!isOpen) {
		return null
	}

	return (
		<Dialog
			isOpen={isOpen}
			onClose={onClose}
			title={title}
			icon={<InfoOutlined />}
		>
			<div className="border border-stroke-light dark:border-stroke-light-dark rounded-lg overflow-hidden shadow-lg box-border">
				<div className="grid grid-cols-[minmax(128px,auto)_1fr]">
					{items
						?.filter(({ visible = true }) => !!visible)
						?.map((item, index) => (
							<Fragment key={index}>
								<div className="px-3 border-b max-w-32 border-stroke-light dark:border-stroke-light-dark min-h-12 box-border flex items-start justify-start py-3 border-r">
									<p className="text-text-main dark:text-text-main-dark text-sm whitespace-nowrap font-bold">
										{item.name}
									</p>
								</div>
								<div
									className={cn(
										'px-3 border-b border-stroke-light dark:border-stroke-light-dark min-h-12 box-border flex items-start justify-start py-3',
										item?.itemClassNameWrapper
									)}
								>
									{typeof item?.value === 'string' ? (
										<p className="text-text-main dark:text-text-main-dark text-lg whitespace-pre-line">
											{item?.value || '-'}
										</p>
									) : (
										item?.value
									)}
								</div>
							</Fragment>
						))}
				</div>
			</div>
		</Dialog>
	)
}

export default ViewInfoModal
